import AsyncStorage from "@react-native-async-storage/async-storage";
import { RequiredDocumentTypeEnum } from "@repo/core/enums/proposals";
import {
  DocumentCaptureState,
  DocumentCaptureStateValues,
  DocumentInfo
} from "@repo/core/stores/documentCapture/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const initialValues: DocumentCaptureStateValues = {
  requiredDocuments: [],
  currentDocumentCapture: RequiredDocumentTypeEnum.DOCUMENT_FRONT,
  cameraFacing: "back",
  hasSelectedAllDocuments: false
};

export const useDocumentCaptureStore = create<DocumentCaptureState>()(
  persist(
    (set, get) => ({
      ...initialValues,
      setRequiredDocuments: (requiredDocuments: DocumentInfo[]) =>
        set({ requiredDocuments }),
      selectDocument: (file: string | null) => {
        const currentDocumentCapture = get().currentDocumentCapture;

        const updatedRequiredDocuments = get().requiredDocuments.map(
          (document) => {
            if (document.strTipoDocumento === currentDocumentCapture) {
              return {
                ...document,
                selectedFile: file
              };
            }
            return document;
          }
        );

        const hasSelectedAllDocuments = updatedRequiredDocuments.every(
          (document) => !!document.selectedFile
        );

        set({
          requiredDocuments: updatedRequiredDocuments,
          hasSelectedAllDocuments
        });
      },
      setCurrentDocumentCapture: (
        currentDocumentCapture: RequiredDocumentTypeEnum
      ) => set({ currentDocumentCapture }),
      setCameraFacing: (cameraFacing: "front" | "back") =>
        set({ cameraFacing }),
      resetDocumentCapture: () => set(initialValues)
    }),
    {
      name: "DocumentCapture",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
